<template>
  <div class="wrapper">
    <BackButton>Step 2: Preview</BackButton>
    <h4 class="compact">
      <small>Step 2</small>
      Prepare to Send Survey
    </h4>
    <hr />
    <form class="pure-form pure-form-aligned" @submit.prevent v-if="surveyDetails">
      <h5>1<sup>st</sup> Tell us about your specific presentation</h5>
      <hr />
      <div class="pure-control-group">
        <label>Presentation Name</label>
        <input
          type="text"
          size="40"
          id="question_text"
          v-model="presentation.name"
          :disabled="presentation.id"
          required />
        <span class="pure-form-message-inline" style="color: #01EEF2">NOTE: Survey takers will see this name.</span>
      </div>
      <div class="pure-control-group">
        <label>Presentation Date</label>
        <datepicker></datepicker>
      </div>
      <h5>2<sup>nd</sup> Click in box and edit text</h5>
      <hr />
      <div class="pure-control-group">
        <label>Request Message</label>
        <textarea :disabled="presentation.id" style="width: 700px; height: 15em;" v-model="presentation.requestMsg"></textarea>
      </div>
      <div class="pure-control-group">
        <label>Thank You Message</label>
        <textarea :disabled="presentation.id" style="width: 700px; height: 7em;" v-model="presentation.thanksMsg"></textarea>
      </div>
      <h5>3<sup>rd</sup> Get the Link</h5>
      <hr />
      <p v-if="!presentation.id">
        <label for="reminder">
        <input type="checkbox" id="reminder" /> Do not notify me when someone fills out survey</label>
      </p>

      <button
        class="pure-button button-secondary button-xlarge"
        :disabled="presentation.name == ''"
        @click="generateLink"
        v-if="!presentation.id">
        Generate Survey Link
      </button>
      <p v-if="presentation.id">
        <a class="pure-button button-success" :href="emailLink">
          <font-awesome-icon icon="envelope" />
          Email Survey
        </a> or
        <a
          class="pure-button button-success"
          :href="copyLink"
        >
          <font-awesome-icon icon="link" />
          Copy survey link and send it how you want.
        </a>
      </p>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex"
import Datepicker from 'vuejs-datepicker'
import BackButton from "@/components/common/BackButton"

export default {
  props: ["id"],
  components: { BackButton, Datepicker },
  data() {
    return {
      link: null,
      presentation: {
        name: "",
        requestMsg: `I just gave a presentation called Presentation name. I need your help so I can improve my presenting skills. Will you please take this 1-2 minute survey?

REALLY BE HONEST AND SPECIFIC. That will help me the most!

The survey is anonymous unless you write your name.

Thank you!

"Those who receive and act on feedback ADVANCE!"`,
        thanksMsg: "Thank you for you time. Your feedback will guide my preparation actions for my future presentations."
      }
    }
  },
  computed: {
    ...mapState(["currentUser", "surveyDetails"]),
    emailLink(presentation) {
      let body = encodeURIComponent(`${this.presentation.welcome_message}\r\r${this.presentation.link_to_survey}`)
      return `mailto:?subject=TorchMetrics: ${this.presentation.name}&body=${body}`
    },
    copyLink() {
      try { window.navigator.clipboard.writeText(this.presentation.link_to_survey) } catch(e) { console.log(e) }
      try { navigator.clipboard.writeText(this.presentation.link_to_survey) } catch(e) { console.log(e) }
    }
  },
  methods: {
    ...mapActions(["ADD_PRESENTATION", "GET_SURVEY_DETAILS"]),
    generateLink() {
      this.ADD_PRESENTATION({
        survey_id: parseInt(this.id),
        name: this.presentation.name,
        welcome_message: this.presentation.requestMsg,
        thank_you_message: this.presentation.thanksMsg
      }).then((res) => {
        this.presentation = res.data
      })
    }
  },
  mounted() {
    this.GET_SURVEY_DETAILS(this.id)
  }
}
</script>

<style>
  .vdp-datepicker { display: inline-block; }

  /* .vdp-datepicker div input[type="text"] { background-color: white; } */
</style>